import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill", "stroke"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewSvg',
  props: {
  width: {
    type: [String, Number],
    default: 13,
  },
  height: {
    type: [String, Number],
    default: 9,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
  stroke: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), [
    _createElementVNode("path", {
      d: "M6.5 3.77539C6.84734 3.77539 7.17621 3.84115 7.48535 3.97363C7.79277 4.10541 8.06169 4.2863 8.29102 4.51562C8.52025 4.74493 8.703 5.01597 8.83887 5.32715C8.97547 5.64019 9.04134 5.96895 9.03711 6.3125C9.03711 6.66376 8.97154 6.99258 8.83887 7.29785C8.70712 7.60088 8.52655 7.86942 8.29785 8.10254C8.06819 8.33662 7.79653 8.51947 7.48438 8.65137C7.17151 8.78354 6.84322 8.84961 6.5 8.84961C6.14874 8.84961 5.81992 8.78404 5.51465 8.65137C5.21162 8.51962 4.94308 8.33905 4.70996 8.11035C4.47613 7.88093 4.29309 7.61161 4.16113 7.30371C4.02865 6.99448 3.96289 6.6638 3.96289 6.3125C3.96289 5.96516 4.02865 5.63629 4.16113 5.32715C4.29291 5.01973 4.4738 4.75081 4.70312 4.52148C4.93219 4.29248 5.2009 4.10955 5.50781 3.97363C5.81725 3.83668 6.14841 3.77116 6.5 3.77539ZM6.49805 4.78711C6.28744 4.78735 6.09195 4.82763 5.91113 4.90625C5.72769 4.98605 5.56451 5.09573 5.4209 5.23535C5.2783 5.37399 5.16987 5.53396 5.09473 5.71582C5.01948 5.898 4.97863 6.09734 4.97461 6.31445C4.97485 6.52506 5.01513 6.72055 5.09375 6.90137C5.17355 7.08481 5.28323 7.24799 5.42285 7.3916C5.56149 7.5342 5.72146 7.64263 5.90332 7.71777C6.08526 7.79292 6.28421 7.8328 6.50098 7.83691C6.71196 7.83679 6.90777 7.79749 7.08887 7.71875C7.27231 7.63895 7.43549 7.52927 7.5791 7.38965C7.7217 7.25101 7.83013 7.09104 7.90527 6.90918C7.98031 6.72751 8.02118 6.52889 8.02539 6.3125L8.01758 6.15723C8.00271 6.00436 7.96544 5.85977 7.90625 5.72363C7.82645 5.54019 7.71677 5.37701 7.57715 5.2334C7.43851 5.0908 7.27854 4.98237 7.09668 4.90723C6.9145 4.83198 6.71516 4.79113 6.49805 4.78711ZM6.5 0.525391C7.11339 0.525391 7.72271 0.599963 8.32715 0.75C8.93226 0.90023 9.50326 1.12616 10.04 1.42676C10.5767 1.72731 11.0623 2.09201 11.4961 2.52148C11.9319 2.95293 12.2896 3.45755 12.5693 4.03418V4.03516C12.7416 4.39265 12.8733 4.76122 12.9639 5.14062C13.0546 5.52076 13.0996 5.91143 13.0996 6.3125C13.0996 6.36773 13.0552 6.41211 13 6.41211H12.1875C12.1323 6.41211 12.0879 6.36773 12.0879 6.3125C12.0879 5.82347 12.0126 5.36682 11.8643 4.94238C11.7151 4.51586 11.5103 4.12665 11.25 3.77539C10.9892 3.42361 10.6783 3.10902 10.3174 2.83105C9.95488 2.55189 9.56919 2.31654 9.16113 2.125C8.75368 1.93377 8.31902 1.78752 7.85645 1.6875C7.39317 1.58733 6.94098 1.53711 6.5 1.53711C6.05059 1.53711 5.59882 1.58751 5.14453 1.6875C4.6903 1.78751 4.25685 1.93353 3.84473 2.125C3.43252 2.31653 3.04497 2.552 2.68262 2.83105C2.32172 3.10901 2.01333 3.42375 1.75684 3.77539C1.50014 4.12731 1.29251 4.51675 1.13477 4.94434C0.978602 5.36765 0.903872 5.82277 0.912109 6.31055C0.912564 6.33736 0.902589 6.36369 0.883789 6.38281C0.864999 6.40186 0.839263 6.41211 0.8125 6.41211H0C-0.0552285 6.41211 -0.0996094 6.36773 -0.0996094 6.3125C-0.0996094 5.91549 -0.0545795 5.52661 0.0361328 5.14648C0.126671 4.76716 0.2585 4.3967 0.430664 4.03516V4.03418C0.70621 3.46595 1.06164 2.96375 1.49707 2.52832C1.93111 2.09428 2.41871 1.72648 2.95996 1.42578C3.50101 1.1252 4.07265 0.901859 4.67383 0.755859C5.27346 0.610254 5.88225 0.533957 6.49902 0.525391H6.5Z",
      fill: __props.fill,
      stroke: __props.stroke,
      "stroke-width": "0.2",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})